import React, { useContext } from "react";
import { EntitiesContext, UserContext } from "../../App";
import { useGetAccountOrders } from "../../hooks/useAccount";

// The consignor's totals for the open sale: what they listed and what sold,
// split by donated vs. non-donated. Shown on more than one consignor page, so
// it loads the paid orders it needs itself rather than trusting that another
// page put them in state first.
export default function ConsignorTotals({ items }) {
  const entities = useContext(EntitiesContext);
  const user = useContext(UserContext);
  const accountOrders = useGetAccountOrders(user.user);
  const orders = entities.state.get("order");

  const total = (inv) => inv.reduce((acc, cur) => acc + parseInt(cur.price), 0);
  const isSold = (i) => i.order(orders)?.status === "paid";

  const nonDonated = items.filter((i) => !i.donate);
  const donated = items.filter((i) => i.donate);

  const body = () => {
    if (accountOrders.isLoading) {
      return (
        <div className="level-item has-text-centered">
          <p className="has-text-grey">Loading your totals…</p>
        </div>
      );
    }

    if (accountOrders.isError) {
      return (
        <div className="level-item has-text-centered">
          <p className="has-text-grey">
            Your totals are unavailable right now. Refresh the page to try again.
          </p>
        </div>
      );
    }

    return (
      <>
        <div className="level-item has-text-centered">
          <div>
            <p className="heading">Total Non Donated Items/Sold*</p>
            <p className="title">
              ${total(nonDonated)}/${total(nonDonated.filter(isSold))}
            </p>
          </div>
        </div>
        <div className="level-item has-text-centered">
          <div>
            <p className="heading">Total Donated/Sold</p>
            <p className="title">
              ${total(donated)}/${total(donated.filter(isSold))}
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <section aria-label="Consignment totals">
      <div className="level mb-2">{body()}</div>
      <p className="is-size-7 has-text-grey has-text-centered mb-5">
        * Please note, the PTA takes 20% of the sold amount.
      </p>
    </section>
  );
}
